import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { terminationLabel } from '@/utils/association-termination';
import { todayBusinessMs } from '@/utils/date-utils';

/**
 * "Terminating 11/30/2026" — bold on a yellow highlight, so a PM can't miss that an association
 * is leaving management (#417). Renders nothing without a termination date.
 *
 * `size="large"` is the hub header; the default fits an association tile.
 */
export const TerminationBadge: React.FC<{
	terminationDate?: number | null;
	size?: 'small' | 'large';
	testID?: string;
}> = ({ terminationDate, size = 'small', testID }) => {
	const label = terminationLabel(terminationDate, todayBusinessMs());
	if (!label) return null;
	const large = size === 'large';
	return (
		<View style={[styles.badge, large && styles.badgeLarge]} testID={testID} accessibilityLabel={label}>
			<Ionicons name="warning" size={large ? 16 : 12} color="#5d4037" />
			<Text style={[styles.text, large && styles.textLarge]}>{label}</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	badge: {
		flexDirection: 'row', alignItems: 'center', gap: 4, alignSelf: 'flex-start',
		backgroundColor: '#ffeb3b', borderRadius: 4, paddingHorizontal: 6, paddingVertical: 2,
		borderWidth: 1, borderColor: '#fbc02d',
	},
	badgeLarge: { paddingHorizontal: 10, paddingVertical: 4 },
	text: { fontSize: 11, fontWeight: '700', color: '#3e2723' },
	textLarge: { fontSize: 15, fontWeight: '800' },
});
